import { useScrollSpy } from '@/utils/hooks';
import { Box, Heading } from '@chakra-ui/react';
import { IndexItem, IndexList } from '@meritcircle/ui/components';
import { ArticleIndexProps } from './academy.types';

export const ArticleIndex = ({ title, headings, ...boxProps }: ArticleIndexProps) => {
  const activeId = useScrollSpy(
    headings.map(({ id }) => `[id="${id}"]`),
    {
      rootMargin: '0% 0% -75% 0%',
    },
  );

  return (
    <Box
      as="nav"
      position="sticky"
      overflowY="auto"
      sx={{ overscrollBehavior: 'contain' }}
      {...boxProps}>
      <Heading as="p" size="lg" mb="8">
        {title}
      </Heading>
      <IndexList>
        {headings.map(({ id, name }) => (
          <IndexItem url={`#${id}`} isActive={id === activeId} key={id}>
            {name}
          </IndexItem>
        ))}
      </IndexList>
    </Box>
  );
};
